<div class="breadcrumb-container" [ngClass]="{ 'breadcrumb-container-compact': compactSidebar }" id="breadcrumb">
  <div class="breadcrumb-component">
    <app-breadcrumb
      [parents]="breadcrumbParents"
      [self]="breadcrumbSelf">
    </app-breadcrumb>
    <div class="breadcrumb-menu d-flex">
      <div *ngIf="rightModel.invoiceTagCreate.hasRight()"
           class="breadcrumb-button-icon-container cursor-pointer negative-margin-right"
           (click)="openInvoiceTagCreateDialog()">
        <a class="btn-setting" title="{{'INVOICE_TAG_CREATE' | translate}}">
          <i class="icomoon icomoon-add"></i>
          <span class="breadcrumb-button-text-visible">{{'INVOICE_TAG_CREATE' | translate}}</span>
        </a>
      </div>
    </div>
  </div>
</div>
<div class="breadcrumb-placeholder"></div>
<div class="container-horizontal-padding container-vertical-padding animated fadeIn">
  <div class="card">
    <div class="card-header">
      {{'MENU_NAVBAR_MENU_INVOICE_TAG_LIST' | translate}}

      <div class="card-actions">
        <a class="btn-setting cursor-pointer" (click)="toggleSearch()" title="{{'COMMON_BUTTON_SEARCH' | translate}}"><i
          class="icomoon icomoon-search"></i></a>
      </div><!-- /.card-actions -->
    </div>

    <div class="card-body border-bottom" *ngIf="showSearch" appHighlightContainer>
      <div class="row form-group">
        <div class="col-md-3">
          <label class="search-label">{{'COMMON_TABLE_HEADER_ID' | translate}}</label>
          <input type="number" class="form-control"
                 placeholder="{{'COMMON_TABLE_HEADER_ID' | translate}}"
                 maxlength="{{UiConstants.maxInputNumberLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.id">
        </div>
        <div class="col-md-3">
          <label class="search-label">{{'INVOICE_TAG_INVOICE_TAG' | translate}}</label>
          <input type="text" class="form-control"
                 placeholder="{{'INVOICE_TAG_INVOICE_TAG' | translate}}"
                 maxlength="{{UiConstants.maximumVarcharLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.invoiceTag">
        </div>
        <div class="col-md-3">
          <label class="search-label">{{'COMMON_DESCRIPTION' | translate}}</label>
          <input type="text" class="form-control"
                 placeholder="{{'COMMON_DESCRIPTION' | translate}}"
                 maxlength="{{UiConstants.maximumVarcharLength}}"
                 (keyup.enter)="onSearchClicked()"
                 [(ngModel)]="searchModel.description">
        </div>
        <div class="col-md-3">
          <label class="search-label">{{'COMMON_SEARCH_CREATION_TIME_FROM' | translate}}</label>
          <div class="input-group">
            <input type="text" class="form-control date"
                   placeholder="{{'COMMON_SEARCH_CREATION_TIME_FROM' | translate}}"
                   [(ngModel)]="searchModel.creationTimeFrom" ngbDatepicker #creation_time_from="ngbDatepicker">
            <div class="input-group-addon-gray" (click)="creation_time_from.toggle()">
              <i class="icomoon icomoon-calendar"></i>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="search-label">{{'COMMON_SEARCH_CREATION_TIME_TO' | translate}}</label>
          <div class="input-group">
            <input type="text" class="form-control date"
                   placeholder="{{'COMMON_SEARCH_CREATION_TIME_TO' | translate}}"
                   [(ngModel)]="searchModel.creationTimeTo" ngbDatepicker #creation_time_to="ngbDatepicker">
            <div class="input-group-addon-gray" (click)="creation_time_to.toggle()">
              <i class="icomoon icomoon-calendar"></i>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <label class="search-label"> {{'COMMON_DISABLED_SEARCH' | translate}} </label>
          <select class="form-control" [(ngModel)]="searchModel.disabled"
                  id="disabled" name="disabled" #disabled="ngModel">
            <option *ngFor="let item of disabledItems" [ngValue]="item.id" >{{item.text}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-md-end align-items-end px-0">
        <div class="btn-group" role="group">
          <button type="button" (click)="onSearchReset()" class="btn btn-outline-primary search-button mr-1">
            {{'COMMON_BUTTON_SEARCH_DELETE' | translate}}
          </button>
          <button type="button" (click)="onSearchClicked()" class="btn btn-primary search-button">
            {{'COMMON_BUTTON_SEARCH' | translate}}
          </button>
        </div>
      </div>
    </div><!-- /.search card-->

    <div class="card-body">
      <table class="table table-striped table-bordered">
        <thead>
        <tr>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.ID"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.ID)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.INVOICE_TAG"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.INVOICE_TAG)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'INVOICE_TAG_INVOICE_TAG' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-xs-down">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.DESCRIPTION"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.DESCRIPTION)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_DESCRIPTION' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-md-down">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.CREATION_TIME"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.CREATION_TIME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TABLE_HEADER_CREATION_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-table-options-menu">
            <app-table-sorter-no-op></app-table-sorter-no-op>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let invoiceTag of invoiceTagList | paginate: {
                                                      itemsPerPage: queryModel.itemsPerPage,
                                                      currentPage: queryModel.currentPage,
                                                      totalItems: queryModel.currentNumberOfItems }"
            [disabledTableRow]="invoiceTag.disabled">
          <td class="fit align-middle">{{invoiceTag.id}}</td>
          <td class="responsive-table-column align-middle">
            <div class="d-flex justify-content-start align-items-center">
              <div>
                <a class="id-text cursor-pointer"
                   href="#" onclick="return false"
                   (click)="openInvoiceTagDetailDialog(invoiceTag.id)"
                   title="{{'COMMON_BUTTON_DETAILS' | translate}}">
                  {{invoiceTag.invoiceTag}}
                </a>
              </div>
            </div>
          </td>
          <td class="responsive-table-column hidden-xs-down align-middle">
            {{invoiceTag.description}}
          </td>
          <td class="fit hidden-md-down align-middle">
              <span class="text-truncate">{{invoiceTag.creationTime.toUtcIsoString() |
                date:'short'}}</span>
          </td>
          <td>
            <app-table-options-menu>
              <app-dropdown-item
                [iconClass]="'icomoon-detail'"
                [titleStringKey]="'COMMON_BUTTON_DETAILS'"
                class="cursor-pointer"
                (click)="openInvoiceTagDetailDialog(invoiceTag.id)">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="invoiceTag.rights.update.hasRight()"
                [iconClass]="'icomoon-modify'"
                [titleStringKey]="'COMMON_BUTTON_EDIT'"
                class="cursor-pointer"
                (click)="openInvoiceTagUpdateDialog(invoiceTag.id)">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="invoiceTag.disabled && invoiceTag.rights.disable.hasRight()"
                [iconClass]="'icomoon-enable'"
                [titleStringKey]="'COMMON_BUTTON_ENABLE'"
                [itemType]="DropdownItemType.ENABLE"
                class="cursor-pointer"
                (click)="setDisabled(invoiceTag.id, false)">
              </app-dropdown-item>
              <app-dropdown-item
                *ngIf="!invoiceTag.disabled && invoiceTag.rights.disable.hasRight()"
                [iconClass]="'icomoon-disable'"
                [titleStringKey]="'COMMON_BUTTON_DISABLE'"
                [itemType]="DropdownItemType.DISABLE"
                class="cursor-pointer"
                (click)="setDisabled(invoiceTag.id, true)">
              </app-dropdown-item>
            </app-table-options-menu>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.ID"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.ID)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TABLE_HEADER_ID' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.INVOICE_TAG"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.INVOICE_TAG)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'INVOICE_TAG_INVOICE_TAG' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-xs-down">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.DESCRIPTION"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.DESCRIPTION)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_DESCRIPTION' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header hidden-md-down">
            <app-table-field-sorter [orderField]="InvoiceTagSearch.OrderFunctions.CREATION_TIME"
                                    [orderType]="queryModel.getOrderType(InvoiceTagSearch.OrderFunctions.CREATION_TIME)"
                                    (orderChange)="orderBy($event)"
                                    [text]="'COMMON_TABLE_HEADER_CREATION_TIME' | translate"></app-table-field-sorter>
          </th>
          <th class="table-sorter-header w-table-options-menu">
            <app-table-sorter-no-op></app-table-sorter-no-op>
          </th>
        </tr>
        </tfoot>
      </table>
      <app-table-paging
        [currentNumberOfItems]="queryModel.currentNumberOfItems"
        [totalNumberOfItems]="queryModel.totalNumberOfItems"
        [itemsPerPage]="queryModel.itemsPerPage"
        (pageChange)="pageChanged($event)"
        (itemsPerPageChange)="itemsPerPageChanged($event)">
      </app-table-paging>
    </div>

  </div>

</div>

